import {
	Card,
	CardHeader,
	CardBody,
	ToggleControl,
	withFilters,
} from '@wordpress/components';

import { Fragment, useContext } from '@wordpress/element';
import { useDispatch } from '@wordpress/data';
import { store as coreDataStore } from '@wordpress/core-data';
import { __, sprintf } from '@wordpress/i18n';
import { SettingsContext } from '../context/settings-context';
import { Promo } from './promo';

export const General = () => {
	const { settings, saveSettings } = useContext( SettingsContext );
	const { editEntityRecord } = useDispatch( coreDataStore );

	const handleChange = ( val ) => {
		editEntityRecord( 'root', 'site', undefined, {
			popper: {
				...settings,
				uninstall: val,
			},
		} );
		saveSettings();
	};

	const promoMessage = sprintf(
		/* translators: Link to site. */
		__(
			'<p>You can add more features to your popups with %s.</p><p>Add mail services integrations, track events in Google Analytics, create your own pattern library to share with your clients sites, send data to <b>Google Sheets</b> or to <b>webhooks</b> and more.</p>',
			'popper'
		),
		`<a href="https://www.francescopepe.com/popper/" target="_blank">Popper Pro</a>`
	);

	return (
		<Fragment>
			<Promo message={ promoMessage } />
			<Card>
				<CardHeader size="small">
					<b>{ __( 'General', 'popper' ) }</b>
				</CardHeader>

				<CardBody>
					<ToggleControl
						label={ __( 'Delete settings on uninstall', 'popper' ) }
						help={ __(
							'Completely remove all Popper settings on uninstall.',
							'popper'
						) }
						checked={ settings.uninstall }
						onChange={ ( val ) => {
							handleChange( val );
						} }
					/>
				</CardBody>
			</Card>
		</Fragment>
	);
};

export default withFilters( 'popper.settings.general' )( General );
